import { destroyElement, toCSS } from 'belter'
import { EVENT } from 'zoid/dist/zoid.frameworks'
import { includeChargebeeScript } from '../common/useChargebee'

const CLASS = {
  VISIBLE: 'zoid-visible',
  INVISIBLE: 'zoid-invisible',
}

export default ({
  uid,
  frame,
  prerenderFrame,
  doc,
  props,
  event,
  dimensions,
}) => {
  const { width } = dimensions

  if (!frame || !prerenderFrame) {
    return
  }

  frame.setAttribute('allowfullscreen', '')

  const div = doc.createElement('div')
  div.setAttribute('id', uid)

  const style = doc.createElement('style')
  if (props.cspNonce) {
    style.setAttribute('nonce', props.cspNonce)
  }

  // Special style for PS 1.7.6 or 1.7.7
  const isPs176Regex = /(1.7.6)/g
  const isPs177Regex = /(1.7.7)/g
  let moreStyleToAppend = ''
  if (
    isPs176Regex.test(props.context.shop_version) ||
    isPs177Regex.test(props.context.shop_version)
  )
    moreStyleToAppend = `
            body.adminpsmbomodule #main-div .content-div {
              padding-top: 42px!important;
            }`

  style.appendChild(
    doc.createTextNode(`
            body.adminpsmbomodule:not(.page-sidebar-closed):not(.mobile) .content-div {
              padding: 0 0 0 13.13rem !important;
            }

            body.adminpsmbomodule.page-sidebar-closed:not(.mobile) .content-div {
              padding: 0 0 0 3.125rem !important;
            }

            body.adminpsmbomodule.mobile .content-div {
              padding: 0 !important;
            }

            body.adminpsmbomodule  {
              background-color: white;
            }

            body.adminpsmbomodule .header-toolbar .container-fluid, body.adminpsmbomodule .header-toolbar .page-head-tabs {
              display: none;
            }

            body.adminpsmbomodule .header-toolbar {
              border-bottom: none;
            }

            body.adminpsmbomodule #main-div #content-message-box {
              position: absolute;
              z-index: 999;
              margin-left: 8px;
              margin-top: 8px;
            }

            body.adminpsmbomodule #main-div .row {
              margin: 0;
              width: 100%;
            }

            body.adminpsmbomodule #main-div .row .col-sm-12 {
              padding: 0;
            }

            body.adminpsmbomodule #main-div .row .col-sm-12 #cdc-container {
              margin: 0;
            }

            #${uid} {
                position: relative;
                width: ${width};
                height: ${getHeigth()};
            }

            #${uid} > iframe {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                transition: opacity .2s ease-in-out;
            }

            #${uid} > iframe.${CLASS.INVISIBLE} {
                opacity: 0;
            }

            #${uid} > iframe.${CLASS.VISIBLE} {
                opacity: 1;
            }

            ${moreStyleToAppend}
        `),
  )

  div.appendChild(frame)
  div.appendChild(prerenderFrame)
  div.appendChild(style)

  prerenderFrame.classList.add(CLASS.VISIBLE)
  frame.classList.add(CLASS.INVISIBLE)

  event.on(EVENT.RENDERED, () => {
    includeChargebeeScript()
    prerenderFrame.classList.remove(CLASS.VISIBLE)
    prerenderFrame.classList.add(CLASS.INVISIBLE)
    frame.classList.remove(CLASS.INVISIBLE)
    frame.classList.add(CLASS.VISIBLE)
    setTimeout(() => {
      destroyElement(prerenderFrame)
    }, 1)
  })

  function getHeigth() {
    const windowHeigth = window.innerHeight
    const psMenuHeigth =
      document.querySelector<HTMLElement>('#header_infos')?.offsetHeight || 0
    const psHeaderToolbarHeigth =
      document.querySelector<HTMLElement>('.header-toolbar')?.offsetHeight || 0

    return windowHeigth - psMenuHeigth - psHeaderToolbarHeigth - 1 + 'px'
  }

  window.addEventListener('resize', () => {
    div.style.height = toCSS(getHeigth())
  })

  document.addEventListener('DOMContentLoaded', () => {
    div.style.height = toCSS(getHeigth())
  })

  $(() => {
    $('.header-toolbar').on('DOMSubtreeModified', () => {
      div.style.height = toCSS(getHeigth())
    })
  })
  return div
}
